import { useState } from "react"
import { useDispatch } from "react-redux"
import { COLORS } from "../../constants"
import { Row, Col } from "reactstrap"
import { CustomInput, CustomButton } from "../../components"
import { useHistory } from "react-router-dom";
import { TiTick } from "react-icons/ti"

import parent from "../../assets/images/parent_avatar.svg"
import teacher from "../../assets/images/teacher_avatar.svg"
import ReactLoading from 'react-loading';
import axios from "axios"
import styled from "styled-components"
import ReactModal from "react-modal"
import { setLoggedUser, setUserRole } from "../../redux/actions"
import Eye from "../../assets/images/eye.svg"
import CrossedEye from "../../assets/images/eye_crossed.svg"

import {
    validateEmail,
    validatePassword,
    checkPasswordMatch,
    validateNames
} from "../../features"
import { grecaptcha, ReCaptchaV3 } from "./ReCaptchaV3"

const StyledAccountSelection = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    border: 3px solid ${COLORS.light_grey_darker};
    border-radius: 10px;
    cursor: pointer;
    transition: box-shadow 0.2s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    &:hover{
        --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }
`;
const EyeImage = styled.img`
    position: absolute; 
    top:  ${props => props.crossed ? "9px" : "14.95px"}; 
    right: 10px;
    cursor: pointer;
    transition: 0.2s opacity;
    &:hover{
        opacity: 0.2;
    }
  
`;
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: 10,
        border: 0
    },
    overlay: {
        backgroundColor: "rgba(0,0,0, 0.5)",
        zIndex: 999
    }
};
export function Register() {
    const history = useHistory();
    const dispatch = useDispatch();
    const api = process.env.REACT_APP_API_URL;
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordRepeat, setPasswordRepeat] = useState('');
    const [loading, setLoading] = useState(false);
    const [parentSelected, setParentSelected] = useState(0);
    const [accountError, setAccountError] = useState('');
    const [passwordShown, setPasswordShown] = useState(false)

    //Errors
    const [errorModal, setErrorModal] = useState(false)
    const [serverError, setServerError] = useState('')
    const [firstNameError, setFirstNameError] = useState('');
    const [lastNameError, setLastNameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [passwordMatchError, setPasswordMatchError] = useState('');


    const handleSubmit = async (e) => {
        e.preventDefault();

        let correct = true;
        let user_type_id;

        setLoading(true);

        if (parentSelected == 1) {
            user_type_id = 1;
        } else if (parentSelected == 2) {
            user_type_id = 2;
        } else if (parentSelected == 0) {
            correct = false;
            setAccountError('Choose parent or teacher account')
        }
        if (!validateNames(firstName)) {
            correct = false;
            setFirstNameError('First name cannot contain numbers or is too short')
        }
        if (!validateNames(lastName)) {
            correct = false;
            setLastNameError('Last name cannot contain numbers or is too short')
        }
        if (!validateEmail(email)) {
            correct = false;
            setEmailError('Check your email. Example john@smith.com')
        }
        if (!validatePassword(password)) {
            correct = false;
            setPasswordError('Check your password.')
        }
        if (!checkPasswordMatch(password, passwordRepeat)) {
            correct = false;
            setPasswordMatchError('Passwords do not match')
        }
        if (correct) {
            const re_captcha_v3_token = document.getElementById('re_captcha_v3_token')?.value;
            console.log(email)
            console.log(password)
            console.log(passwordRepeat)
            console.log(firstName)
            console.log(lastName)
            console.log(user_type_id)
            axios.post(`${api}/register`, {
                email: email,
                password: password,
                password_confirmation: passwordRepeat,
                first_name: firstName,
                last_name: lastName,
                user_type_id: user_type_id,
                re_captcha_v3_token
            },
                {
                    headers: {
                        'Accept': 'application/json'
                    }
                }).then(res => {
                    console.log("error #2")
                    const result = res.data;
                    setLoading(false)
                    if (result.message) {
                        setServerError(result.message)
                        setErrorModal(true);

                    }
                    if (result.user) {

                        // localStorage.setItem('authToken', result.access_token);
                        // localStorage.setItem('role', result.user_role)
                        // localStorage.setItem('user', JSON.stringify(result));
                        // dispatch(setLoggedUser(result))
                        // dispatch(setUserRole(result.user_role))

                        history.replace('/')

                    }
                }).catch(error => {
                    console.log(error.status)
                    setServerError('The user with provided email address already exists')
                    setErrorModal(true);
                    setLoading(false);
                    grecaptcha()
                });
        } else {
            setLoading(false)
        }
    }
    return (
        <>
            <ReCaptchaV3 />
            <ReactModal ariaHideApp={false} isOpen={errorModal} contentLabel="Error" role="dialog" style={customStyles} onRequestClose={() => setErrorModal(false)}>
                <div className="d-flex flex-column align-items-center">
                    <h5>Error</h5>
                    {serverError}
                    <CustomButton
                        style={{ width: 200, marginTop: 10 }}
                        color={COLORS.text_dark_green}
                        bgColor={COLORS.green}
                        hover={COLORS.text_green}
                        onClick={() => setErrorModal(false)}
                    >
                        Close
                    </CustomButton>
                </div>
            </ReactModal>
            <div className="m-0 h-100 w-100 p-4">

                <Col lg>
                    <h4 className="text-center-responsive" style={{ color: COLORS.text_green }}>Register</h4>
                </Col>

                <Row className="m-0">
                    <Col lg>
                        <h6 style={{ color: COLORS.text_grey }} className="m-0">Choose an Account</h6>
                    </Col>
                </Row>
                <Row className="m-0">
                    <Col lg className="mt-responsive">
                        <StyledAccountSelection onClick={() => setParentSelected(1)}>
                            <img src={parent} width={50} />
                            <h5 className="m-0 px-3">Parent</h5>
                            <div
                                className="circle-sm"
                                style={{ background: COLORS.green }}
                            >
                                {parentSelected == 1 && <TiTick size={40} color={COLORS.text_dark_green} />}
                            </div>
                        </StyledAccountSelection>
                    </Col>
                    <Col lg className="mt-responsive">
                        <StyledAccountSelection onClick={() => setParentSelected(2)}>
                            <img src={teacher} width={50} />
                            <h5 className="m-0 px-2">Teacher</h5>
                            <div
                                className="circle-sm"
                                style={{ background: COLORS.green }}
                            >
                                {parentSelected == 2 && <TiTick size={40} color={COLORS.text_dark_green} />}
                            </div>
                        </StyledAccountSelection>
                    </Col>
                </Row>
                <Col>
                    <div className="text-left" style={{ fontSize: 14, color: "red" }}>{accountError}</div>
                </Col>
                <form autoComplete="off">
                    <Row className="mx-0">
                        <Col lg className="mt-3">
                            <h6>First Name</h6>
                            <CustomInput type="text" className="w-100" value={firstName} onChange={(event) => {
                                setFirstName(event.target.value)
                                setFirstNameError('')
                            }} />
                            <div className="text-left" style={{ fontSize: 14, color: "red" }}>{firstNameError}</div>
                        </Col>
                        <Col lg className="mt-3">
                            <h6>Last Name</h6>
                            <CustomInput type="text" className="w-100" value={lastName} onChange={(event) => {
                                setLastName(event.target.value)
                                setLastNameError('');
                            }} />
                            <div className="text-left" style={{ fontSize: 14, color: "red" }}>{lastNameError}</div>
                        </Col>
                    </Row>
                    <Row className="mx-0">
                        <Col lg className="mt-3">
                            <h6>Email Address</h6>
                            <CustomInput type="email" className="w-100" value={email} onChange={(event) => {
                                setEmail(event.target.value)
                                setEmailError('')
                            }} />
                            <div className="text-left" style={{ fontSize: 14, color: "red" }}>{emailError}</div>
                        </Col>
                    </Row>
                    <Row className="mx-0">
                        <Col lg className="mt-3">
                            <h6>Password</h6>
                            <CustomInput type={passwordShown ? "text" : "password"} className="w-100" value={password} onChange={(event) => {
                                setPassword(event.target.value)
                                setPasswordError('')
                            }} />
                            <div className="text-left" style={{ fontSize: 14, color: "red" }}>{passwordError}</div>
                        </Col>
                        <Col lg className="mt-3">
                            <h6>Repeat Password</h6>
                            <div style={{ position: "relative" }}>
                                <CustomInput type={passwordShown ? "text" : "password"} className="w-100" value={passwordRepeat} onChange={(event) => setPasswordRepeat(event.target.value)} disabled={password.length < 1} />
                                <EyeImage crossed={passwordShown} src={passwordShown ? Eye : CrossedEye} width="30" onClick={() => setPasswordShown(!passwordShown)} />
                            </div>
                        </Col>
                    </Row>
                    <Row className="mx-0 mt-1">
                        <Col>
                            <div style={{ fontSize: 14 }} className="color-text-grey">Password should contain uppercase, lowercase letter, number and have more than 7 characters</div>
                        </Col>
                    </Row>
                    <Row className="mx-0 mt-3">
                        <Col>
                            {!checkPasswordMatch(password, passwordRepeat) && <div className="text-center" style={{ fontSize: 14, color: "red" }}>{passwordMatchError}</div>}
                        </Col>
                    </Row>
                    <Row className="mx-0 flex-column-reverse flex-lg-row">
                        <Col lg className="mt-4">

                            <CustomButton className="px-4 w-100"
                                color={COLORS.dark_orange}
                                bgColor={COLORS.orange}
                                hover={COLORS.orange_hover}
                                onClick={(event) => {
                                    event.preventDefault();
                                    history.goBack()
                                }}
                            >
                                Go Back
                            </CustomButton>

                        </Col>
                        <Col lg className="d-flex justify-content-end mt-4">
                            <CustomButton
                                type="submit"
                                className="px-4 w-100"
                                color={COLORS.text_dark_green}
                                bgColor={COLORS.green}
                                hover={COLORS.text_green}
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? <><ReactLoading type="spin" color={COLORS.text_dark_green} height={20} width={20} className="d-inline-block" /><span className="ml-2">Loading...</span></> : 'Register'}
                            </CustomButton>
                        </Col>
                    </Row>
                </form>
            </div>
        </>
    );
}